interface AsyncStateProps {
  state: 'loading' | 'error' | 'empty';
  message?: string;
  onRetry?: () => void;
}

export function AsyncState({ state, message, onRetry }: AsyncStateProps) {
  if (state === 'loading') {
    return (
      <div className="state-panel" role="status" aria-live="polite">
        <span className="spinner" aria-hidden="true" />
        <span>{message ?? 'Loading workspace…'}</span>
      </div>
    );
  }

  if (state === 'error') {
    return (
      <div className="state-panel state-panel--error" role="alert">
        <div>
          <strong>Something needs attention</strong>
          <p>{message ?? 'The workspace could not be loaded.'}</p>
        </div>
        {onRetry ? (
          <button className="button button--secondary" type="button" onClick={onRetry}>
            Try again
          </button>
        ) : null}
      </div>
    );
  }

  return (
    <div className="state-panel">
      <span>{message ?? 'No records yet.'}</span>
    </div>
  );
}
